import React from 'react'
import './contact.css'
import {HiOutlineMail} from 'react-icons/hi'
import {BsGithub, BsLinkedin} from 'react-icons/bs'

const contacts = [
  {
    icon: <HiOutlineMail aria-hidden="true" />,
    label: 'Email',
    detail: 'mikefang456@gmail.com',
    href: 'mailto:mikefang456@gmail.com',
    action: 'Send an email'
  },
  {
    icon: <BsLinkedin aria-hidden="true" />,
    label: 'LinkedIn',
    detail: 'michael-d-fang',
    href: 'https://www.linkedin.com/in/michael-d-fang/',
    action: 'Connect on LinkedIn'
  },
  {
    icon: <BsGithub aria-hidden="true" />,
    label: 'GitHub',
    detail: 'FlyinPandaa',
    href: 'https://github.com/FlyinPandaa',
    action: 'View GitHub'
  }
]

const Contact = () => (
  <section id="contact">
    <h5>Contact</h5>
    <h2>Let&apos;s connect</h2>

    <div className="container contact__container">
      <div className="contact__intro">
        <p>I am interested in early-career opportunities across product management, technical program management, software engineering, and AI-enabled tools.</p>
        <a href="mailto:mikefang456@gmail.com" className="btn btn-primary">Email Michael</a>
      </div>
      <div className="contact__options">
        {contacts.map(({icon, label, detail, href, action}) => (
          <a className="contact__option" href={href} key={label} target={href.startsWith('http') ? '_blank' : undefined} rel={href.startsWith('http') ? 'noopener noreferrer' : undefined}>
            <span className="contact__option-icon">{icon}</span>
            <span><strong>{label}</strong><small>{detail}</small></span>
            <span className="contact__action">{action}</span>
          </a>
        ))}
      </div>
    </div>

    <a href="#top" className="scroll__up">Back to top</a>
  </section>
)

export default Contact
